<template>
  <div class="table33">
    <el-table :data="list" height="850" style="width: 100%" ref="table" @sort-change='sortChange'>
      <el-table-column prop="" label="基金">
        <template slot-scope="scope">
          <div style="font-size: 15px; color: #333333">
            {{ scope.row.ths_stock_short_name_stock }}
          </div>
          <div style="font-size: 13px; color: #999999">
            {{ scope.row.code }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="latest" label="现价" sortable='custom' align="center">
        <template slot-scope="scope">
          <div style="font-size: 15px" :class="{'colorRed':scope.row.change_ratio && scope.row.change_ratio > 0,'colorGreen':scope.row.change_ratio && scope.row.change_ratio < 0}">
            {{ scope.row.latest || '--'}}
          </div>
          <div style="font-size: 10px" :class="{'colorRed':scope.row.change_ratio && scope.row.change_ratio > 0,'colorGreen':scope.row.change_ratio && scope.row.change_ratio < 0}">
            {{ scope.row.change_ratio || '--' }}<i v-if="scope.row.change_ratio">%</i>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="ths_turnover_rate_on_debut_stock" label="当日换手率" align="center" sortable='custom'>
        <template slot-scope="scope">
          {{scope.row.ths_turnover_rate_on_debut_stock || '--'}} <i v-if="scope.row.ths_turnover_rate_on_debut_stock">%</i>
        </template>
      </el-table-column>
      <el-table-column prop="sealing_plate" label="当前封板(亿元)" align="center" sortable='custom'>
        <template slot-scope="scope">
          {{scope.row.sealing_plate || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="ths_current_mv_stock" label="流通市值(亿元)" align="center" sortable='custom'>
        <template slot-scope="scope">
          {{scope.row.ths_current_mv_stock || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="ths_close_on_debut_stock" label="开板收盘价" align="center">
        <template slot-scope="scope">
          {{scope.row.ths_close_on_debut_stock || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="single_sign_income" label="单签收益(元)" align="center">
        <template slot-scope="scope">
          {{scope.row.single_sign_income || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="ths_chang_ratio_on_debut_stock" label="开板后涨幅" align="center">
        <template slot-scope="scope">
          {{scope.row.ths_chang_ratio_on_debut_stock || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="data7" label="操作" align="center">
        <template>
          <img src="../../../../public/img/index3/add.png" alt="" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {beforeNewStockList} from '../../../http/index.js'
export default {
  props:{
    
  },
  data() {
    return {
      list:[],
      page:1,
      page_number:20,
      sortObj:{
        sort:'ths_chang_ratio_on_debut_stock desc'
      },

    };
  },

  mounted() {
    this.getlist()
    // 获取需要绑定的table
    this.dom = this.$refs.table.bodyWrapper
    this.dom.addEventListener('scroll', () => {
        // 滚动距离
        let scrollTop = this.dom.scrollTop
        let canshu = 350 * this.page
        console.log(canshu);
        console.log(scrollTop);
        if(scrollTop > canshu){
          this.getMore()
        }
    })
  },
  methods:{
    getMore() {
      this.page++
      this.getlist()
    },
    getlist(){
      let obj = this.sortObj
      let params = Object.assign({},{page:this.page,page_number:this.page_number},obj)
      beforeNewStockList(params).then((res)=>{
        if(this.page == 1){
          this.list = res.data.list
        }else{
          this.list = this.list.concat(res.data.list)
        }
      })
    },
    sortChange(a){
      this.page = 1
      this.list = []
      let canshu1 = a.prop
      let canshu2 
      if(a.order == 'ascending'){
        canshu2 = 'asc'
      }else if(a.order == 'descending'){
        canshu2 = 'desc'
      }else{
        canshu2 = null
      }
      if(canshu2 == null){
        this.sortObj = {}
        this.getlist()
      }else{
        let obj = {sort: `${canshu1} ${canshu2}`}
        this.sortObj = obj
        this.getlist()
      }
    }
  }
};
</script>

<style scoped>
.table33 {
  min-width: 1427px;
  position: relative;
}

th img {
  width: 8px;
  height: 15px;
  vertical-align: middle;
  margin-left: 6px;
}
td img {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.ssd {
  background-color: #539cff;
  font-size: 10px;
  height: 13px;
  line-height: 13px;
  border-radius: 3px;
  color: #fefefe;
  padding: 0 5px;
}

i {
  font-style: normal;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.fontSize16 {
  font-size: 16px;
}
.colorRed {
  color: #fd4c4c;
}
.colorBlue {
  color: #4372ba;
}
.colorGreen {
  color: #41b357;
}
.BackColorGreen {
  background-color: #41b357;
}
.BackColorBlue {
  background-color: #4372ba;
}
.table33 /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.table33 /deep/ .cell {
  padding: 0;
}
.table33 /deep/ .el-table th.el-table__cell > .cell {
  padding: 0;
}
</style>